/**
 * Genera un layout apilado en columna para breakpoints móviles (xs/xxs).
 * Cada widget ocupa todo el ancho (x: 0, w: cols) y se apila verticalmente.
 *
 * @param {Array<{i: string, x: number, y: number, w: number, h: number, ...}>} layoutItems - Items del layout original
 * @param {number} cols - Número de columnas del breakpoint (ej. 4 para xs, 2 para xxs)
 * @returns {Array} Layout con items apilados (x: 0, w: cols, y acumulado)
 */
export const buildStackedLayout = (layoutItems, cols) => {
  if (!layoutItems?.length) return [];

  const sorted = [...layoutItems].sort((a, b) => {
    if (a.y !== b.y) return a.y - b.y;
    return a.x - b.x;
  });

  let currentY = 0;
  return sorted.map((item) => {
    const stacked = {
      ...item,
      x: 0,
      w: cols,
      y: currentY,
    };
    currentY += item.h;
    return stacked;
  });
};
